import PropTypes from 'prop-types'
import { Box, Button, Dialog, Icon, Heading, Text } from '@redriverpress/system'

export default function ResetConfirmDialog({
  open,
  handleOpenChange,
  onCancel,
  onConfirmOk,
}) {
  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.StyledContent
          $zIndex={8}
          onOpenAutoFocus={e => {
            e.preventDefault()
          }}
          onPointerDownOutside={e => {
            e.preventDefault()
            handleOpenChange(false)
          }}
          style={{ overflowY: 'auto' }}
        >
          {/* Title */}
          <Box display='flex' alignItems={['baseline', null, 'center']} py={3}>
            <Dialog.Title asChild>
              <Heading as='h6' mb={0}>
                Are you sure you want to exit the sign up process?
              </Heading>
            </Dialog.Title>

            <Box ml='auto'>
              <Dialog.Close />
            </Box>
          </Box>

          {/* Content */}
          <Text my={2}>
            Exiting out of this sign-up process before completing it will result
            in losing any information you’ve&nbsp;entered.
          </Text>

          {/* Buttons */}
          <Box
            mb={2}
            mt={4}
            display='flex'
            flexDirection={['column', null, 'row']}
            justifyContent='center'
            width={1}
          >
            <Button
              onClick={onConfirmOk}
              mx={2}
              mb={[3, null, 0]}
              secondary
              adaptive
            >
              <Icon icon='door-open' mr={2} />
              Leave page
            </Button>
            <Button mx={2} onClick={onCancel} adaptive>
              <Icon icon='door-closed' mr={2} />
              Stay on page
            </Button>
          </Box>
        </Dialog.StyledContent>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

ResetConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleOpenChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirmOk: PropTypes.func.isRequired,
}
